import { Sparkles } from 'lucide-react'

import { AgentSidePanel } from '../AgentChat/AgentSidePanel'
import { useInternalAgent } from './InternalAgentProvider'
import { usePageContext } from './pageContext'

/** The internal agent as a right-hand panel, available on every internal page. */
export function InternalAgentDrawer() {
  const panel = useInternalAgent()
  const pageContext = usePageContext()

  return (
    <AgentSidePanel
      panel={panel}
      pageContext={pageContext}
      title="Internal agent"
      icon={<Sparkles className="text-brand-700 size-5 shrink-0" />}
      emptyStateDescription="Ask the agent to search, create, or edit anything — it can see the page you’re on."
      // Clear of the fixed comms bar.
      bottomClassName="bottom-[50px]"
      showDocumentPreview
    />
  )
}
